import socketService from '../service/service'
import { ADMIN_DASHBOARD_DETAILS ,GET_ALLCASES,GET_GROUP_BASED_USER_DETAILS} from '../../types'

export function adminDashboardListener(dispatch, user) {
  const socket = socketService.getSocket()
  if (!socket) return // safety check
  socket.on('adminDashboardUpdate', ({ groupId = 2, data, success,caseCreationStatics }) => {
    if (user.type === groupId && success) {
      dispatch({
        type: ADMIN_DASHBOARD_DETAILS,
        payload: { data },
      })
      dispatch({
        type: GET_ALLCASES,
        payload: {data:caseCreationStatics},
      })
    }
  })
}


export function userDashboardListener(dispatch, user) {
  const socket = socketService.getSocket();
  if (!socket) return; // safety check

  socket.on("user_dashboard_trigger", ({ groupId = 1 }) => {
    if (user.type === groupId) {
      socket.emit("get_user_dashboard", { userId: user.userId }, (res) => {
        if (res?.success && res.userId === user.userId) { // ✅ exact userId check
          dispatch({
            type: GET_GROUP_BASED_USER_DETAILS,
            payload: {data:res.data},
          });
        }
      });
    }
  });
}
// Cleanup function
export function cleanupDashboardListeners() {
  const socket = socketService.getSocket()
  if (!socket) return

  socket.off('functionMapUpdated')
  socket.off('caseUpdated')
  socket.off('userUpdated')
  socket.off('groupUpdated')
  socket.off('messageUpdated')
  socket.off('adminDashboardUpdate')
  socket.off('statisticsUpdated')
}
